export default {
    profile: state => state.profile,
    profileRequestStatus: state => state.profileRequestStatus,
};
